import axios from "axios";
import { useMutation } from "react-query";

const API_URL = "https://backend.masterclick.in/api/v1";
  // const API_URL= "http://127.0.0.1:8001/api_master_mart/api/v1";

const SendOtp = () => {
  return useMutation(
    async (payload) => {
      const { phoneNumber } = payload;
      const { data } = await axios.post(API_URL + "/auth/login/", {
        mobile: phoneNumber,
        device: "pwa",
      });
      return data;
    },
    {
      onSuccess: (response) => {},
    },
    {
      onError: (error) => {},
    }
  );
};

const VerifyOtp = () => {
  return useMutation(
    async (payload) => {
      const { mobile, otp } = payload;
      const { data } = await axios.post(API_URL + "/auth/mobile/otp/verify/", {
        mobile,
        otp,
      });
      return data;
    },
    {
      onSuccess: (response) => {
        localStorage.setItem("accessToken", response.data.token.access);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        localStorage.setItem("refreshToken", response.data.token.refresh);
      },
    },
    {
      onError: (error) => {},
    }
  );
};

const Registration = () => {
  return useMutation(
    async (payload) => {
      const { data } = await axios.post(API_URL + "/auth/register/", {
        name: payload.name,
        mobile: payload.mobile,
        image: payload.image,
        location: payload.location,
      });
      return data;
    },
    {
      onSuccess: (response) => {},
    },
    {
      onError: (error) => {},
    }
  );
};

/**
 * CheckMobile — checks if a mobile number exists and is already verified.
 * API should return: { exists: bool, is_verified: bool, token: { access, refresh }, user: {...} }
 * If the backend returns tokens directly (verified user), we store them.
 */
const CheckMobile = () => {
  return useMutation(
    async (payload) => {
      const { mobile } = payload;
      const { data } = await axios.post(API_URL + "/auth/check-mobile/", {
        mobile,
        device: "pwa",
      });
      return data;
    },
    {
      onSuccess: (response) => {
        // If backend returns tokens for a verified user, store them immediately
        if (response?.data?.token?.access) {
          localStorage.setItem("accessToken", response.data.token.access);
          localStorage.setItem("user", JSON.stringify(response.data.user));
          localStorage.setItem("refreshToken", response.data.token.refresh);
        }
      },
    }
  );
};

/**
 * PasswordLogin — authenticates with mobile (username) + password.
 * Used by the lower "already registered profile" section.
 */
const PasswordLogin = () => {
  return useMutation(
    async (payload) => {
      const { username, password } = payload;
      const { data } = await axios.post(API_URL + "/auth/login/", {
        username,      // mobile number used as username
        password,
        device: "pwa",
      });
      return data;
    },
    {
      onSuccess: (response) => {
        if (response?.data?.token?.access) {
          localStorage.setItem("accessToken", response.data.token.access);
          localStorage.setItem("user", JSON.stringify(response.data.user));
          localStorage.setItem("refreshToken", response.data.token.refresh);
        }
      },
    }
  );
};

const useAuthQuery = {
  SendOtp,
  VerifyOtp,
  Registration,
  CheckMobile,
  PasswordLogin,
};
export default useAuthQuery;
